{
  "NAMESPACE_MAPPING": {
    "anchors": "anchors_data",
    "atomicScopes": "atomicScopes",
    "behaviors": "behaviors_data",
    "breakpoints": "breakpoints_data",
    "classnames": "classnames",
    "connections": "connections_data",
    "contentRole": "contentRole",
    "controllers": "controllers",
    "cursor": "cursor",
    "data": "document_data",
    "design": "design_data",
    "discussions": "discussions",
    "editorsettings": "editorsettings",
    "effects": "effects",
    "fixerVersions": "fixerVersions",
    "grouping": "grouping",
    "innerElements": "innerElements",
    "innerElementsMetaData": "innerElementsMetaData",
    "intent": "intent",
    "layout": "layout_data",
    "layoutSettings": "layoutSettings",
    "manifest": "manifest",
    "measurements": "measurements",
    "migration": "migration",
    "mobileHints": "mobile_hints",
    "naming": "naming",
    "notifications": "notifications",
    "pageSections": "pageSections",
    "patterns": "patterns",
    "presets": "presets",
    "props": "component_properties",
    "reactions": "reactions",
    "slots": "slots",
    "source": "source",
    "states": "states",
    "style": "theme_data",
    "themeConfig": "themeConfig",
    "transformations": "transformations_data",
    "transitions": "transitions_data",
    "triggers": "triggers",
    "variables": "variables",
    "variants": "variants_data"
  },
  "PAGE_DATA_DATA_TYPES": {
    "anchors": "anchors_data",
    "atomicScopes": "atomicScopes",
    "behaviors": "behaviors_data",
    "breakpoints": "breakpoints_data",
    "classnames": "classnames",
    "connections": "connections_data",
    "contentRole": "contentRole",
    "controllers": "controllers",
    "cursor": "cursor",
    "data": "document_data",
    "design": "design_data",
    "discussions": "discussions",
    "editorsettings": "editorsettings",
    "effects": "effects",
    "fixerVersions": "fixerVersions",
    "grouping": "grouping",
    "innerElements": "innerElements",
    "innerElementsMetaData": "innerElementsMetaData",
    "intent": "intent",
    "layout": "layout_data",
    "layoutSettings": "layoutSettings",
    "manifest": "manifest",
    "measurements": "measurements",
    "migration": "migration",
    "mobileHints": "mobile_hints",
    "naming": "naming",
    "notifications": "notifications",
    "pageSections": "pageSections",
    "patterns": "patterns",
    "presets": "presets",
    "props": "component_properties",
    "reactions": "reactions",
    "slots": "slots",
    "source": "source",
    "states": "states",
    "style": "theme_data",
    "themeConfig": "themeConfig",
    "transformations": "transformations_data",
    "transitions": "transitions_data",
    "triggers": "triggers",
    "variables": "variables",
    "variants": "variants_data"
  },
  "VIEWER_PAGE_DATA_TYPES": {
    "anchors": "anchors_data",
    "behaviors": "behaviors_data",
    "breakpoints": "breakpoints_data",
    "classnames": "classnames",
    "connections": "connections_data",
    "controllers": "controllers",
    "cursor": "cursor",
    "data": "document_data",
    "design": "design_data",
    "effects": "effects",
    "fixerVersions": "fixerVersions",
    "innerElements": "innerElements",
    "innerElementsMetaData": "innerElementsMetaData",
    "intent": "intent",
    "layout": "layout_data",
    "mobileHints": "mobile_hints",
    "patterns": "patterns",
    "presets": "presets",
    "props": "component_properties",
    "reactions": "reactions",
    "slots": "slots",
    "states": "states",
    "style": "theme_data",
    "transformations": "transformations_data",
    "transitions": "transitions_data",
    "triggers": "triggers",
    "variables": "variables",
    "variants": "variants_data"
  },
  "VIEWER_DATA_TYPES": {
    "anchors": "anchors",
    "behaviors": "behaviors",
    "breakpoints": "breakpoints",
    "classnames": "classnames",
    "connections": "connections",
    "controllers": "controllers",
    "cursor": "cursor",
    "data": "data",
    "design": "design",
    "effects": "effects",
    "fixerVersions": "fixerVersions",
    "innerElements": "innerElements",
    "innerElementsMetaData": "innerElementsMetaData",
    "intent": "intent",
    "layout": "layout",
    "mobileHints": "mobileHints",
    "patterns": "patterns",
    "presets": "presets",
    "prop": "props",
    "reactions": "reactions",
    "slots": "slots",
    "states": "states",
    "theme": "style",
    "transformations": "transformations",
    "transitions": "transitions",
    "triggers": "triggers",
    "variables": "variables",
    "variants": "variants"
  },
  "EDITOR_DATA_TYPES": {
    "atomicScopes": "atomicScopes",
    "contentRole": "contentRole",
    "discussions": "discussions",
    "editorsettings": "editorsettings",
    "grouping": "grouping",
    "layoutSettings": "layoutSettings",
    "manifest": "manifest",
    "measurements": "measurements",
    "migration": "migration",
    "naming": "naming",
    "notifications": "notifications",
    "pageSections": "pageSections",
    "source": "source",
    "themeConfig": "themeConfig"
  },
  "DATA_TYPES": {
    "anchors": "anchors",
    "atomicScopes": "atomicScopes",
    "behaviors": "behaviors",
    "breakpoints": "breakpoints",
    "classnames": "classnames",
    "connections": "connections",
    "contentRole": "contentRole",
    "controllers": "controllers",
    "cursor": "cursor",
    "data": "data",
    "design": "design",
    "discussions": "discussions",
    "editorsettings": "editorsettings",
    "effects": "effects",
    "fixerVersions": "fixerVersions",
    "grouping": "grouping",
    "innerElements": "innerElements",
    "innerElementsMetaData": "innerElementsMetaData",
    "intent": "intent",
    "layout": "layout",
    "layoutSettings": "layoutSettings",
    "manifest": "manifest",
    "measurements": "measurements",
    "migration": "migration",
    "mobileHints": "mobileHints",
    "naming": "naming",
    "notifications": "notifications",
    "pageSections": "pageSections",
    "patterns": "patterns",
    "presets": "presets",
    "prop": "props",
    "reactions": "reactions",
    "slots": "slots",
    "source": "source",
    "states": "states",
    "theme": "style",
    "themeConfig": "themeConfig",
    "transformations": "transformations",
    "transitions": "transitions",
    "triggers": "triggers",
    "variables": "variables",
    "variants": "variants"
  },
  "FEATURES_PAGE_DATA_TYPES": {
    "classnames": "classnames",
    "contentRole": "contentRole",
    "cursor": "cursor",
    "discussions": "discussions",
    "editorsettings": "editorsettings",
    "grouping": "grouping",
    "innerElementsMetaData": "innerElementsMetaData",
    "intent": "intent",
    "layoutSettings": "layoutSettings",
    "manifest": "manifest",
    "measurements": "measurements",
    "migration": "migration",
    "naming": "naming",
    "notifications": "notifications",
    "pageSections": "pageSections",
    "presets": "presets",
    "source": "source",
    "themeConfig": "themeConfig"
  },
  "COMP_DATA_QUERY_KEYS": {
    "anchors": "anchorQuery",
    "behaviors": "behaviorQuery",
    "breakpoints": "breakpointsQuery",
    "classnames": "classnamesQuery",
    "connections": "connectionQuery",
    "contentRole": "contentRoleQuery",
    "controllers": "controllersQuery",
    "cursor": "cursorQuery",
    "data": "dataQuery",
    "design": "designQuery",
    "discussions": "discussionsQuery",
    "editorsettings": "editorsettingsQuery",
    "effects": "effectsQuery",
    "fixerVersions": "fixerVersionsQuery",
    "grouping": "groupingQuery",
    "innerElements": "innerElementsQuery",
    "innerElementsMetaData": "innerElementsMetaDataQuery",
    "intent": "intentQuery",
    "layout": "layoutQuery",
    "layoutSettings": "layoutSettingsQuery",
    "manifest": "manifestQuery",
    "measurements": "measurementsQuery",
    "migration": "migrationQuery",
    "mobileHints": "mobileHintsQuery",
    "naming": "namingQuery",
    "notifications": "notificationsQuery",
    "pageSections": "pageSectionsQuery",
    "patterns": "patternsQuery",
    "presets": "presetsQuery",
    "props": "propertyQuery",
    "reactions": "reactionsQuery",
    "slots": "slotsQuery",
    "source": "sourceQuery",
    "states": "statesQuery",
    "themeConfig": "themeConfigQuery",
    "transformations": "transformationQuery",
    "transitions": "transitionQuery",
    "triggers": "triggersQuery",
    "variables": "variablesQuery",
    "variants": "breakpointVariantsQuery"
  },
  "COMP_DATA_QUERY_KEYS_WITH_STYLE": {
    "anchors": "anchorQuery",
    "behaviors": "behaviorQuery",
    "breakpoints": "breakpointsQuery",
    "classnames": "classnamesQuery",
    "connections": "connectionQuery",
    "contentRole": "contentRoleQuery",
    "controllers": "controllersQuery",
    "cursor": "cursorQuery",
    "data": "dataQuery",
    "design": "designQuery",
    "discussions": "discussionsQuery",
    "editorsettings": "editorsettingsQuery",
    "effects": "effectsQuery",
    "fixerVersions": "fixerVersionsQuery",
    "grouping": "groupingQuery",
    "innerElements": "innerElementsQuery",
    "innerElementsMetaData": "innerElementsMetaDataQuery",
    "intent": "intentQuery",
    "layout": "layoutQuery",
    "layoutSettings": "layoutSettingsQuery",
    "manifest": "manifestQuery",
    "measurements": "measurementsQuery",
    "migration": "migrationQuery",
    "mobileHints": "mobileHintsQuery",
    "naming": "namingQuery",
    "notifications": "notificationsQuery",
    "pageSections": "pageSectionsQuery",
    "patterns": "patternsQuery",
    "presets": "presetsQuery",
    "props": "propertyQuery",
    "reactions": "reactionsQuery",
    "slots": "slotsQuery",
    "source": "sourceQuery",
    "states": "statesQuery",
    "style": "styleId",
    "themeConfig": "themeConfigQuery",
    "transformations": "transformationQuery",
    "transitions": "transitionQuery",
    "triggers": "triggersQuery",
    "variables": "variablesQuery",
    "variants": "breakpointVariantsQuery"
  },
  "DATA_TYPE_BY_COMP_DATA_QUERY": {
    "anchorQuery": "anchors",
    "behaviorQuery": "behaviors",
    "breakpointsQuery": "breakpoints",
    "classnamesQuery": "classnames",
    "connectionQuery": "connections",
    "contentRoleQuery": "contentRole",
    "controllersQuery": "controllers",
    "cursorQuery": "cursor",
    "dataQuery": "data",
    "designQuery": "design",
    "discussionsQuery": "discussions",
    "editorsettingsQuery": "editorsettings",
    "effectsQuery": "effects",
    "fixerVersionsQuery": "fixerVersions",
    "groupingQuery": "grouping",
    "innerElementsQuery": "innerElements",
    "innerElementsMetaDataQuery": "innerElementsMetaData",
    "intentQuery": "intent",
    "layoutQuery": "layout",
    "layoutSettingsQuery": "layoutSettings",
    "manifestQuery": "manifest",
    "measurementsQuery": "measurements",
    "migrationQuery": "migration",
    "mobileHintsQuery": "mobileHints",
    "namingQuery": "naming",
    "notificationsQuery": "notifications",
    "pageSectionsQuery": "pageSections",
    "patternsQuery": "patterns",
    "presetsQuery": "presets",
    "propertyQuery": "props",
    "reactionsQuery": "reactions",
    "slotsQuery": "slots",
    "sourceQuery": "source",
    "statesQuery": "states",
    "styleId": "style",
    "themeConfigQuery": "themeConfig",
    "transformationQuery": "transformations",
    "transitionQuery": "transitions",
    "triggersQuery": "triggers",
    "variablesQuery": "variables",
    "breakpointVariantsQuery": "variants",
    "variantsQuery": "variants"
  },
  "SERIALIZED_SCOPED_DATA_KEYS": {
    "cursor": "scopedCursor",
    "design": "scopedDesigns",
    "effects": "scopedEffects",
    "layout": "scopedLayouts",
    "layoutSettings": "scopedLayoutSettings",
    "presets": "scopedPresets",
    "reactions": "scopedReactions",
    "style": "scopedStyles",
    "transformations": "scopedTransformations",
    "transitions": "scopedTransitions"
  },
  "ALIAS_NAMESPACES": {
    "DESKTOP": "structure",
    "MOBILE": "structure"
  },
  "OVERRIDE_NAMESPACES": {
    "multilingualTranslations": "data"
  },
  "VARIANTS_DATA_TYPES": {
    "cursor": "cursor",
    "design": "design",
    "discussions": "discussions",
    "effects": "effects",
    "layout": "layout",
    "layoutSettings": "layoutSettings",
    "presets": "presets",
    "reactions": "reactions",
    "style": "style",
    "transformations": "transformations",
    "transitions": "transitions",
    "variables": "variables"
  },
  "DATA_TYPES_SUPPORT_VARIANTS_BUT_NOT_SCOPED_ON_ROOT": {
    "effects": "effects",
    "variables": "variables"
  },
  "EXCLUDED_NAMESPACES_FROM_VIEWER_REF_FETCH": {
    "classnames": "classnames"
  }
}
